import {
    documentEventDispatcher,
    EVENT_ADD_TO_CART, EVENT_CALCULATE_SHIPPING, EVENT_GENERATE_GIFT_WRAP, EVENT_GENERATE_UPSELLS,
    EVENT_HIDE_MINI_CART_LOADER, EVENT_REMOVE_GIFTS,
    EVENT_SHOW_MINI_CART, EVENT_SHOW_QUANTITY_UPSELL, EVENT_TOGGLE_CHECKOUT, EVENT_UPDATE_PRICES
} from "./eggo-cart-events";
import {hideDomElement, moneyToFloat, percentageDiscount, finalPriceFormat} from "../helpers";
import {registerProductCardCartColors, buttonAddToCart} from "./product-card";
import {EggoCartDiscountLogic} from "./eggo-cart-logic";
import {EggoCartShipping} from "./eggo-cart-shipping";
import {addToCart, removeItemCart} from "./mini-cart";

export class EggoCart {
    constructor() {
        this.cartDrawer = null;
        this.cartCache = null;
        this.eggoCartRealWrapper = document.querySelector(".cart-notification-wrapper");
        this.registerAddToCartGlobalEvent();
        this.registerHideMiniCartLoaderEvent();
        this.registerOpenMiniCartEvent();
        this.registerGiftGlobalEvent();
        this.registerUpdatePricesEvent();
        this.registerEventCartShipping();
        this.timeout = null;
    }

    init(content) {
        this.eggoCartWrapper = document.createElement("div");
        this.eggoCartWrapper.innerHTML = content ? content : this.getCartContent();
        this.eggoCart = this.eggoCartWrapper.querySelector(".cart-notification-inner-wrapper");

        if (this.cartCache) {
            this.activateFakeCart(false);
        }

        this.registerInitialEvents();
    }

    setWrapperLoading() {
        this.eggoCartRealWrapper.classList.add("loading");
    }

    unsetWrapperLoading() {
        this.eggoCartRealWrapper.classList.remove("loading");
    }

    getCart(url = `${routes.cart_update_url}.js`, body = {updates: {}}) {
        this.setWrapperLoading();
        this.cartRequest(url, body);
    }

    refreshCart() {
        const mainCartWrapper = document.querySelector(".cart-notification-wrapper");
        mainCartWrapper.innerHTML = "";
        mainCartWrapper.append(this.eggoCart);
    }

    getCartContent() {
        return document.querySelector(".cart-notification-inner-wrapper").outerHTML;
    }

    registerInitialEvents() {
        this.registerMiniCartCloseEvents();
        this.registerLineItemQuantityChangeEvent();
        this.registerLineItemRemoveEvent();
        this.registerCouponEvents();
        this.registerAddToCartGifts();
        registerProductCardCartColors(this.eggoCart.querySelector(".cart-drawer__inner-real"));
    }

    registerMiniCartCloseEvents() {
        /** Close mini cart on background click **/
        this.registerClickCloseEvent(".cart-notification__bg");

        /** Close mini cart on X click **/
        this.registerClickCloseEvent(".cart-drawer__inner-real .cart-drawer__close");

        /** Close mini cart on ESC **/
        document.addEventListener("keyup", (event) => {
            if (event.key === "Escape") this.actionCloseMiniCart(event);
        })
    }

    registerClickCloseEvent(className) {
        const miniCartBg = this.eggoCart.querySelector(className);
        if (!miniCartBg) return;
        miniCartBg.addEventListener("click", (e) => this.actionCloseMiniCart(e));
    }

    registerLineItemQuantityChangeEvent() {
        const quantityElements = this.eggoCart.querySelectorAll(".cart-item__quantity .quantity");
        quantityElements.forEach((quantityElement) => {
            quantityElement.addEventListener("change", () => {
                const newQuantity = parseInt(quantityElement.input.value);
                const productId = quantityElement.input.dataset.product;
                this.actionUpdateCartQuantity(productId, newQuantity);
            });
        });
    }

    registerLineItemRemoveEvent() {
        const removeElements = this.eggoCart.querySelectorAll(".cart-item__remove button");
        removeElements.forEach((removeElement) => {
            removeElement.addEventListener("click", () => {
                const productId = removeElement.dataset.product;
                this.actionUpdateCartQuantity(productId, 0);
            });
        });
    }

    registerCouponEvents() {
        const toggleButton = this.eggoCart.querySelector(".cart-drawer__inner-real .cart-drawer__footer-coupon-toggle");
        if (!toggleButton) return;
        toggleButton.addEventListener("click", () => {
            hideDomElement(toggleButton);
            this.actionShowCouponField();
        });
    }

    registerAddToCartGifts() {
        const buttons = this.eggoCart.querySelectorAll(".is-add-to-cart:not(.eggo-button--buy)");
        if (!buttons) return;
        buttons.forEach((button) => button.addEventListener("click", buttonAddToCart));
    }


    actionCloseMiniCart(e) {
        e.preventDefault();
        this.eggoCart.classList.remove("open");
        documentEventDispatcher(EVENT_SHOW_QUANTITY_UPSELL, {});
    }


    actionShowLoader() {
        this.eggoCart.classList.add("loading")
    }

    actionShowCouponField() {
        const eggoCouponFieldElement = this.eggoCart.querySelector(".cart-drawer__inner-real #stack-discounts-input-block");
        if (eggoCouponFieldElement) eggoCouponFieldElement.classList.add("visible");
    }

    registerOpenMiniCartEvent() {
        document.addEventListener(EVENT_SHOW_MINI_CART, () => {
            this.eggoCart.classList.add("open");
        });
    }

    registerHideMiniCartLoaderEvent() {
        document.addEventListener(EVENT_HIDE_MINI_CART_LOADER, (event) => {
            this.eggoCart.classList.remove("loading")
            const giftData = this.getGift();
            const cartItems = this.cartDrawer.querySelectorAll(`.cart-item:not([data-variant-id="${giftData.id}"])`);
            this.registerGiftWrapEvents();
            if (!giftData?.id) return;
            if (cartItems.length === 0) {
                this.registerRemoveGiftEvents();
            }
        })
    }

    registerRemoveGiftEvents() {
        const giftData = this.getGift();
        if (giftData.id) {
            removeItemCart(giftData.id);
        }
    }

    registerUpdatePricesEvent() {
        document.addEventListener(EVENT_UPDATE_PRICES, (e) => {
            this.cartUpdatePrices(e.detail);
        });
    }

    registerAddToCartGlobalEvent() {
        document.addEventListener(EVENT_ADD_TO_CART, (event) => {
            if (this.eggoCart) {
                documentEventDispatcher(EVENT_SHOW_MINI_CART);
            } else {
                this.setWrapperLoading();
            }
            this.cartRequest(event.detail.url, event.detail.data);
        });
    }

    registerGiftGlobalEvent() {
        document.addEventListener(EVENT_GENERATE_UPSELLS, (event) => {
            new EggoCartDiscountLogic(this.eggoCart);
        });
    }

    registerEventCartShipping() {
        document.addEventListener(EVENT_CALCULATE_SHIPPING, (event) => {
            new EggoCartShipping(event.detail, this.eggoCart);
        });
    }

    /** Cart manipulation **/
    actionUpdateCartQuantity(productId, quantity) {
        this.cartRequest(`${routes.cart_update_url}.js`, {
            updates:
                {
                    [productId]: quantity
                }
        });
    }

    activateFakeCart = (clearCache = false) => {
        const fakeElement = this.eggoCart.querySelector(".cart-drawer__inner-fake");
        fakeElement.innerHTML = this.cartCache;
        if (clearCache) this.cartCache = null;
    }
    setFakeCart = () => {
        const realElement = this.eggoCart.querySelector(".cart-drawer__inner-real");
        const fakeDom = document.createElement("div");
        fakeDom.innerHTML = realElement.innerHTML;
        const footer = fakeDom.querySelector("#stack-discounts-container");
        if (footer) footer.setAttribute("id", "");
        this.cartCache = fakeDom.innerHTML;
    }

    cartRequest = (url, body) => {
        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        if (this.eggoCart) {
            this.actionShowLoader();
            this.setFakeCart();
            this.activateFakeCart();
        }
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                ...body,
                sections: "cart-drawer",
                sections_url: "/cart"
            })
        }).then(response => response.json())
            .then(async (data) => {
                /** Show smooth open if cart is closed or not loaded at all **/
                const smoothOpenMiniCart = !this.eggoCart || !this.eggoCart.classList.contains("open");
                const tempDom = document.createElement("div");
                try {
                    tempDom.innerHTML = data.sections["cart-drawer"];
                } catch (error) {
                    //Fallback if sections api stops working.
                    tempDom.innerHTML = await fetch(`${routes.cart_url}?sections=cart-drawer`).then(response => response.json()).then(data => {
                        return data["cart-drawer"];
                    })
                }
                this.cartDrawer = tempDom;
                if (smoothOpenMiniCart) {
                    this.init(tempDom.querySelector("#shopify-section-cart-drawer").innerHTML);
                    setTimeout(() => {
                        this.eggoCart.classList.add("open");
                        this.eggoCart.classList.add("loading");
                    }, 1);
                } else {
                    const cartWrapper = tempDom.querySelector(".cart-notification-inner-wrapper");
                    cartWrapper.classList.add("open");
                    cartWrapper.classList.add("loading");
                    this.init(tempDom.querySelector("#shopify-section-cart-drawer").innerHTML);
                }


                this.unsetWrapperLoading();
                this.refreshCart();

                if (data.item_count === 0) {
                    setTimeout(() => {
                        documentEventDispatcher(EVENT_HIDE_MINI_CART_LOADER);
                    }, 1);
                }
                this.isCartStillLoading();
            })
    }

    isCartStillLoading() {
        this.timeout = setTimeout(() => {
            if (this.eggoCart.classList.contains("loading")) {
                documentEventDispatcher(EVENT_HIDE_MINI_CART_LOADER);
                window.location = "/cart";
            }
        }, 16000);
    }

    cartUpdatePrices(cartUpdates) {
        Object.entries(cartUpdates).forEach(([cartItemKey, cartItemHtml]) => {
            const variantId = cartItemKey.split("=")[1];
            const newFinalPriceDomElement = document.createElement("div");
            newFinalPriceDomElement.innerHTML = cartItemHtml;
            const newPriceDom = newFinalPriceDomElement.querySelector("span[dy-cart-item-discounted-price]");
            if (!newPriceDom) return;
            const newPrice = newPriceDom.innerHTML;
            const cartItemDomElement = this.eggoCart.querySelector(`.cart-drawer__inner-real .cart-item[data-variant-id='${variantId}']`);
            if (!cartItemDomElement) return;
            const priceDomElement = cartItemDomElement.querySelector(".cart-item__price");
            const finalPriceDomElement = cartItemDomElement.querySelector(".cart-item__final-price");
            const discountDomElement = cartItemDomElement.querySelector(".small-discount-badge");
            const quantityDomElement = cartItemDomElement.querySelector(".quantity__input");
            if (!finalPriceDomElement) return;
            finalPriceDomElement.innerHTML = newPrice;

            if (!priceDomElement.querySelector(".cart-item__percentage")) {
                this.prependCompareAtPrice(priceDomElement, moneyToFloat(newPrice), quantityDomElement.value);
            } else {
                if (discountDomElement) {
                    const highPriceSingle = discountDomElement.dataset.high;
                    const quantity = quantityDomElement.value;
                    const highPrice = highPriceSingle * quantity;
                    const highPriceFloat = highPrice / 100;
                    const newPriceFloat = moneyToFloat(newPrice);
                    discountDomElement.innerHTML = percentageDiscount(newPriceFloat, highPriceFloat);
                }
            }
            finalPriceDomElement.innerHTML = finalPriceFormat(newPrice);
        });
    }

    prependCompareAtPrice(priceWrapperElement, newPrice, quantity) {
        if (!newPrice) return;
        const priceData = priceWrapperElement.dataset;
        let price = null;
        if (priceData?.comparePrice) {
            price = priceData.comparePrice;
        } else {
            if (priceData?.price) {
                price = priceData.price;
            } else {
                return;
            }
        }
        const newPriceFinal = newPrice * 100 / parseInt(quantity);
        const oldPriceFinal = moneyToFloat(price, true) * 100 / parseInt(quantity);
        const percentage = percentageDiscount(newPriceFinal, oldPriceFinal);
        priceWrapperElement.innerHTML = `
                <div class="cart-item__discounted-prices">
                <s class='cart-item__old-price product-price'>${price}</s>
                ${finalPriceFormat(priceWrapperElement.innerHTML)}
                <span data-high="${oldPriceFinal}" class="cart-item__percentage small-discount-badge">${percentage}</span>
                </div>`;
    }

    registerGiftWrapEvents() {
        const giftData = this.getGift();
        if (!giftData.element) return;
        giftData.element.addEventListener("click", () => {
            if (giftData.element.classList.contains("item-is-checked")) {
                removeItemCart(giftData.id);
            } else {
                addToCart([{
                    id: giftData.id,
                    quantity: 1
                }]);
            }
        });
    }

    getGift() {
        const giftWrapper = this.eggoCart.querySelector(".cart-drawer__inner-real .cart-drawer__footer-gift__inner");
        let giftId = null;
        if (giftWrapper) {
            giftId = giftWrapper.dataset?.productId;
        }
        return {
            element: giftWrapper,
            id: giftId
        }
    }
}